import { forwardRef, useCallback, useState } from "react";
import { Chip } from "@mui/material";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import FileSaver from 'file-saver';

const DownloadChip = forwardRef( ({ url, icon = (<DownloadForOfflineIcon sx={{  fontSize: 26  }} />), filename, download, ...props }, ref) => {
    const [downloading, setDownloading] = useState(false);

    const handleAction = useCallback(async () => {
        if (downloading) return false;
        setDownloading(true);

        try {
            await download(blob => {
                FileSaver.saveAs(blob, filename);
                setDownloading(false);
            }, url);
        } catch (e) {
            setDownloading(false);
            throw e;
        }
    }, [downloading, download, filename, url]);

    return (
        <Chip ref={ref} disabled={downloading} icon={icon}  onClick={handleAction} {...props} />
    )
});

export default DownloadChip;
